import React, { useState } from "react";
import Slider from "react-slick";
import CustomDropDown from "../../utils/CustomDropDown";

import useBenefitsStore from "../state";

export const Filter = () => {
    const benefits = useBenefitsStore((store) => store.benefits);
    const filterBenefits = useBenefitsStore((store) => store.filterBenefits);
    const categories = useBenefitsStore((store) => store.categories);

    const defaultFilter = { name: "Todos" };
    const [selectedFilter, setSelectedFilter] = useState(defaultFilter);

    const iconClose = `${window._env_.STATIC_HOST}/static/website/images/icons/close.svg`;

    // Configuración slider
    const calculateSlidesToShow = (n) => {
        return categories.length > n ? n : categories.length + 1;
    };
    const settings = {
        className: "benefits-filter__slider",
        infinite: false,
        speed: 500,
        slidesToShow: calculateSlidesToShow(7),
        initialSlide: 0,
        variableWidth: true,
        // Media Queries
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: calculateSlidesToShow(5),
                    variableWidth: false,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: calculateSlidesToShow(4),
                },
            },
        ],
    };

    const handleFilter = (filter) => {
        setSelectedFilter(filter);
        filterBenefits(filter);
    };

    return (
        <div className='benefits-filter'>
            <Slider {...settings}>
                <div
                    className={`filter__item ${selectedFilter?.name == "Todos" ? "active" : ""
                        }`}
                    onClick={() => handleFilter(defaultFilter)}>
                    Todos ({benefits.length})
                </div>
                {categories.map((category) => (
                    <div
                        className={`filter__item ${selectedFilter?.name == category.name
                            ? "active"
                            : ""
                            }`}
                        key={category.id}
                        onClick={() =>
                            selectedFilter?.name != category.name &&
                            handleFilter(category)
                        }>
                        {category.name} ({category.amount})
                        {selectedFilter?.name == category.name && (
                            <img
                                src={iconClose}
                                className='filter__close-icon'
                                onClick={() => handleFilter(defaultFilter)}
                            />
                        )}
                    </div>
                ))}
            </Slider>

            <CustomDropDown
                items={[defaultFilter, ...categories]}
                onClickOption={handleFilter}
            />
        </div>
    );
};
